"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = register;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function register() {
  return _register.apply(this, arguments);
}
function _register() {
  _register = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
    var p,
      _p$enableServiceWorke,
      enableServiceWorker,
      serviceWorkerResolve,
      serviceWorkerReject,
      serviceWorkerRegisterOptions,
      _args3 = arguments;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          p = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _p$enableServiceWorke = p.enableServiceWorker, enableServiceWorker = _p$enableServiceWorke === void 0 ? true : _p$enableServiceWorke, serviceWorkerResolve = p.serviceWorkerResolve, serviceWorkerReject = p.serviceWorkerReject, serviceWorkerRegisterOptions = p.serviceWorkerRegisterOptions;
          if ("serviceWorker" in navigator && enableServiceWorker) {
            navigator.serviceWorker.register('/serviceWorker.js', serviceWorkerRegisterOptions).then(function (reg) {
              if (serviceWorkerResolve) {
                return serviceWorkerResolve({
                  reg: reg
                });
              }
            })["catch"](function (err) {
              if (serviceWorkerReject) {
                serviceWorkerReject({
                  err: err
                });
              }
            });
          } else {
            if (!enableServiceWorker) {
              navigator.serviceWorker.getRegistrations().then( /*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(registrations) {
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return Promise.all(registrations.map( /*#__PURE__*/function () {
                          var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(reg) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                              while (1) switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return reg.unregister();
                                case 2:
                                  return _context.abrupt("return", _context.sent);
                                case 3:
                                case "end":
                                  return _context.stop();
                              }
                            }, _callee);
                          }));
                          return function (_x2) {
                            return _ref2.apply(this, arguments);
                          };
                        }()));
                      case 2:
                        if (!serviceWorkerReject) {
                          _context2.next = 4;
                          break;
                        }
                        return _context2.abrupt("return", serviceWorkerReject({
                          info: {
                            message: "ServiceWorker not enabled"
                          }
                        }));
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            } else {
              if (serviceWorkerReject) {
                serviceWorkerReject({
                  err: {
                    message: "Browser not support ServiceWorker"
                  }
                });
              }
            }
          }

          /*function checkForUpdate(registration) {
              registration.addEventListener("updatefound", function() {
                  if (navigator.serviceWorker.controller) {
                      var installingWorker = registration.installing;
                      installingWorker.onstatechange = function() {
                          console.info("Service Worker State :", installingWorker.state);
                          // eslint-disable-next-line default-case
                          switch(installingWorker.state) {
                              case 'installed':
                                  navigator.serviceWorker.ready
                                      .then(function (registration) {
                                          registration.showNotification('Site Content Updated\n Please Refresh.')
                                      });
                                  break;
                              case 'redundant':
                                  throw new Error('The installing service worker became redundant.');
                          }
                      }
                  }
              });
          }*/
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _register.apply(this, arguments);
}